import { IJsonQuery } from '@cian/api-models/common/json_query';
import { ISearchMetaResponseSchema11 } from '@cian/api-models/monolith-python/cian-api/site/v1/offers/search/meta';

import { IMakeRequest } from '../../app/helpers/network_helper';

export interface IGetMetaParameters {
  jsonQuery: IJsonQuery;
}

export function getMeta(
  makeRequest: IMakeRequest,
  parameters: IGetMetaParameters,
): Promise<ISearchMetaResponseSchema11> {
  return makeRequest({
    method: 'POST',
    headers: [
      ['Accept', 'application/json'],
      ['Content-Type', 'application/json'],
    ],
    uri: {
      path: '/cian-api/site/v1/offers/search/meta/',
    },
    body: JSON.stringify(parameters.jsonQuery),
  });
}
